export type HlsStartupVariant = "baseline" | "fragment-prefetch";

function stableBucket(value: string) {
  let hash = 2166136261;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0) % 100;
}

function playbackSessionId(uri?: string) {
  const query = uri?.split("?", 2)[1] ?? "";
  for (const pair of query.split("&")) {
    const [rawKey, rawValue = ""] = pair.split("=", 2);
    try {
      if (decodeURIComponent(rawKey).toLowerCase() === "playsessionid") {
        return decodeURIComponent(rawValue);
      }
    } catch {
      if (rawKey.toLowerCase() === "playsessionid") return rawValue;
    }
  }
  return "";
}

/** Stable 10% web canary for hls.js first-fragment prefetch. */
export function getHlsStartupVariant(uri?: string): HlsStartupVariant {
  const identity = playbackSessionId(uri);
  return identity && stableBucket(`${identity}:worker`) < 10
    ? "fragment-prefetch"
    : "baseline";
}

/** Keep browser startup/rebuffer runway responsive without changing fidelity. */
export function getHlsSegmentLength(playSessionId?: string) {
  if (!playSessionId) return 4;
  const bucket = stableBucket(`${playSessionId}:segment-length`);
  if (bucket < 5) return 2;
  return 4;
}
